export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Proveedor\",\n    \"label_other\": \"{{count}} proveedores\"\n}\n"